export const FeatureGroups = {
  general:[
    "age",
    "young",

    //"attractive",
    "gender",
    "expression",

    "race",
  ],

  hair:[
    "hair_color_type",
    "color_hair",

    "black_hair",
    "blond_hair",
    "brown_hair",
    "gray_hair",

    "bald",
    "bangs",

    "receding_hairline",
    "straight_hair",
    "wavy_hair",

    "hair_sides",
    "hair_top",
    "hair_forehead",
    "hair_length",
  ],

  facial_hair:[
    "5oclock_shadow",
    "beard",
    "goatee",
    "mustache",
    "sideburns",
    "hair_beard",
    "hair_mustache",
  ],


  skin:[
    "pale_skin",
    "color_skin",
  ],

  face_shape:[
    "chubby",
    "oval_face",
    "head_shape",
    "head_width",
  ],

  eye_brows:[
    "arched_eyebrows",
    "bushy_eyebrows",
    "eyebrows_corners",
    "eyebrows_position",
    "eyebrows_size",
  ],

  eyes:[
    "glasses",
    "glasses_rim",
    "bags_under_eyes",
    "heavy_makeup",
    "narrow_eyes",
    "color_eyes",
    "eyes_corners",
    "eyes_distance",
    "eyes_position",
    "eyes_shape",
  ],

  cheeks:[
    "high_cheekbones",
    "rosy_cheeks",
  ],

  nose:[
    "big_nose",
    "pointy_nose",
    "nose_shape",
    "nose_width",
  ],

  mouth:[
    "big_lips",
    "mouth_open",
    "wearing_lipstick",
    "mouth_corners",
    "mouth_height",
    "mouth_width",
    "teeth_visible",
  ],

  chin:[
    "double_chin",
    "chin_size",
  ],

  accessories:[
    "wearing_earrings",
    "wearing_hat",
    "wearing_necklace",
    "wearing_necktie",
  ],

  clothes:[
    "color_background",
    "color_clothes_middle",
    "color_clothes_sides",
  ],

  image_quality:[
    "blurry",
  ],

  orientation:[
    "pitch",
    "yaw",
    "roll"
  ]
}
